<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <about-user :aboutUserNav="aboutUserNav"></about-user>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
  <div class="user-main-right">
    <form  @submit.prevent="submitInfo">
      <h2 class="user-order-title">意见反馈</h2>
<div class="user-main-right-content">
      <textarea placeholder="请详细写下您的意见与感想吧，最多200字哟~" class="feedback-input" maxlength="200" @input="contentInput" v-model="content" />
      <input type="text" oninput="this.value=this.value.replace(/[\u4e00-\u9fa5]/ig, '')" placeholder="联系方式：QQ/电话号码/邮箱" class="contact-way" v-model="contact" maxlength="30">

      <div class="add-img">
        <div class="head_img">
          <div class="default-head" v-for="(item,index) in addImg" :key="index">
            <div class="del-img" @click="deleteImg(index)"><img src="../../../static/images/syy-images/delete.png"/></div>
            <img :src="item"/>
          </div>
          <div class="default-head-info">
            <i class="plus"><img src="../../../static/images/syy-images/jaihao.png" alt=""></i>
            <p>添加图片</p>
            <form ref="form" enctype="multipart/form-data">
              <input type="file" ref="referenceUpload" multiple accept="image/*" @change="handleFile" class="hiddenInput" name="file"/>
            </form>
          </div>
        </div>
      </div>
      <div class="info-modify-div">
        <button class="preservation-btn" type="submit">提交</button>
      </div>
</div>
    </form>
  </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import AboutUser from '.././components/about-user.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/tjs/tool'
  import axios from 'axios'
  let imgArr =[];
  let fileArr = [];
  export default {
    name: "feedback",
    data () {
      return {
        navActive:5,
        aboutUserNav:2,
        txtVal: 0,//已经输入多少个字
        content:"",//描述
        contact:"",//联系方式
        addImg: [],
        uploadImg:[],//图片数组
        file:[]
      }
    },
    components: {
      AboutUser,
      navCom,
      footerCom
    },
    methods: {
      contentInput(){
        this.txtVal = this.content.length;
      },
      uploadHeadImg: function () {
        this.$el.querySelector('.hiddenInput').click()
      },

      /**
       * 上传图片
       */
      handleFile: function (e) {
        let $target = e.target || e.srcElement;
        if($target.files.length + this.addImg.length < 4){
          let file = $target.files;
          for (let i = 0; i < $target.files.length; i++){
            let reader = new FileReader();
            reader.onload = (data) => {
              let res = data.target || data.srcElement;
              imgArr.push(res.result);
              this.addImg = imgArr
            };
            reader.readAsDataURL(file[i])
          }
          /*上传图片 start*/
         var formData = new FormData(this.$refs.form);
         console.log(formData)
         axios.post('/api/Base/uploadPic', formData)
            .then(res => {
              console.log(454546,res.data.url)
                fileArr.push(res.data.url)
              this.file = fileArr;
            });
          this.$refs.referenceUpload.value = null;

          /*上传图片 end*/
        }else{
          this.$toast.center('最多上传3张图片');
        }
      },

      /**
       * 图片删除
       */
      deleteImg:function(e){
        this.addImg.splice(e,1);
        this.file.splice(e,1);
      },
      /**
       *提交反馈
       */
      submitInfo: function(e) {
        var that = this;
        let data = {
          user_id: this.$store.state.uuid,
          content: this.content,
          contact: this.contact,
          pic_url: this.file,
        };
        axios.post('/api/about/feedback', data)
          .then(function (res) {
            /** 成功 : 1 **/
            console.log(565689,res)
            if (res.data.code == 200) {
              that.$toast.center('感谢您的反馈');
              that.content = '';
              that.contact = '';
              that.addImg.splice(e,3);
              that.file.splice(e,3);
            }
            /** 失败 : 0/3 **/
            else {
              /** 提示错误信息 : 0  **/
              if (res.data.code == 400) {
                that.$toast.center(res.data.msg);
              }
            }

          })
      }
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto;
  }
  .all-whole{
    background: #fbfbfb;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height:720px;
    background: #ffffff;
  }
  .user-order-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
  }
  .feedback-input{
    width: 791px;
    height: 247px;
    background: #f2f2f2;
    border-radius: 6px;
    resize: none;
    padding: 13px 10px;
     -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    border: none;
    outline: none;
  }
  .feedback-input::-webkit-input-placeholder{
    color: #cecece;
  }
  .feedback-input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #cecece;
  }
  .feedback-input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #cecece;
  }
  .feedback-input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #cecece;
  }
  .contact-way{
    width: 791px;
    height: 50px;
    padding-left: 10px;
    box-sizing: border-box;
    background: #f2f2f2;
    border-radius: 6px;
    margin-top: 22px;
    border: none;
    outline: none;
  }
  .contact-way::-webkit-input-placeholder{
    color: #cecece;
  }
  .contact-way::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #cecece;
  }
  .contact-way:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #cecece;
  }
  .contact-way:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #cecece;
  }
  .add-img{
    position: relative;
    margin-top: 23px;
  }
  .head_img{
    display: inline-block;
    position: relative;
    vertical-align: middle;
  }
  .default-head img{
    width: 100%;
    height: 100%;
  }
  .default-head-info{
    width: 88px;
    height: 88px;
    overflow: hidden;
    background: #f2f2f2;
    border-radius: 7px;
    display: inline-block;
    position: relative;
  }
  .default-head-info p{
    font-size: 14px;
    color: #c9c9c9;
    text-align: center;
  }
  .default-head-info input{
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 88px;
    height: 88px;
    cursor: pointer;
  }
  .plus{
    width: 26px;
    height: 26px;
    font-size: 50px;
    color: #9b9b9b;
    text-align: center;
    display: block;
    margin: 12px auto;
  }
  .plus img{
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  .info-modify-div{
    position: relative;
  }
  .preservation-btn{
    cursor:pointer;
    width: 182px;
    height: 49px;
    background: #1a71ff;
    font-size: 16px;
    color: #fff;
    line-height: 49px;
    text-align: center;
    margin-top: 53px;
    display: inline-block;
    outline: none;
    border: none;
    border-radius: 8px;
  }
  .del-img{
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,0.3);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
  }
  .default-head .del-img img {
    width: 40%;
    height: 40%;
  }
  .default-head:hover .del-img{
    visibility: visible;
  }
  .user-main-right-content{
    margin-left: 20px;
  }
  .default-head{
    width:88px;
    height:88px;
    overflow: hidden;
    display: inline-block;
    margin-right: 15px;
    border-radius: 7px;
    position: relative;
  }
  .default-head img{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about-user/feedback.vue